var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseWhiteYellowMustardBgRoundedNavyBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#AA8208",
    stroke: "#333541"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.03448C11.5 8.46315 10.9404 8 10.25 8C9.55964 8 9 8.46315 9 9.03448V18.9655C9 19.5368 9.55964 20 10.25 20C10.9404 20 11.5 19.5368 11.5 18.9655V9.03448Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.03448C19 8.46315 18.4404 8 17.75 8C17.0596 8 16.5 8.46315 16.5 9.03448V18.9655C16.5 19.5368 17.0596 20 17.75 20C18.4404 20 19 19.5368 19 18.9655V9.03448Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.03448C11.5 8.46315 10.9404 8 10.25 8C9.55964 8 9 8.46315 9 9.03448V18.9655C9 19.5368 9.55964 20 10.25 20C10.9404 20 11.5 19.5368 11.5 18.9655V9.03448Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.03448C19 8.46315 18.4404 8 17.75 8C17.0596 8 16.5 8.46315 16.5 9.03448V18.9655C16.5 19.5368 17.0596 20 17.75 20C18.4404 20 19 19.5368 19 18.9655V9.03448Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseWhiteYellowMustardBgRoundedNavyBorder);
export default __webpack_public_path__ + "static/media/pauseWhiteYellowMustardBgRoundedNavyBorder.a989867c0723a022d089890bf948da9b.svg";
export { ForwardRef as ReactComponent };